// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.library-page[data-v-0eea6c40] {
  width: min(1280px, calc(100vw - 28px));
  margin: 0 auto;
  padding: 28px 0 56px;
  color: #f7f1e8;
}
.library-hero[data-v-0eea6c40],
.library-broadcast-inner[data-v-0eea6c40],
.library-card[data-v-0eea6c40],
.library-manifesto[data-v-0eea6c40] {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 32px;
  background:
    radial-gradient(circle at top left, rgba(255, 240, 0, 0.14), transparent 24%),
    linear-gradient(150deg, rgba(24, 18, 10, 0.96), rgba(10, 11, 16, 0.96));
  box-shadow:
    0 24px 60px rgba(0, 0, 0, 0.36),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
}
.library-hero[data-v-0eea6c40] {
  padding: 30px;
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(280px, 0.9fr);
  gap: 18px;
  transform: rotate(-0.6deg);
}
.library-kicker[data-v-0eea6c40],
.library-broadcast-kicker[data-v-0eea6c40],
.library-card-index[data-v-0eea6c40] {
  margin: 0 0 10px;
  color: #fff000;
  font-size: 12px;
  letter-spacing: 4px;
  text-transform: uppercase;
}
.library-title[data-v-0eea6c40] {
  margin: 0;
  color: #fffdf7;
  font-size: clamp(56px, 11vw, 110px);
  line-height: 0.88;
  text-shadow:
    0 0 18px rgba(255, 240, 0, 0.18),
    4px 4px 0 rgba(0, 0, 0, 0.32);
}
.library-lead[data-v-0eea6c40],
.library-side-copy[data-v-0eea6c40],
.library-broadcast-copy[data-v-0eea6c40],
.library-card-copy[data-v-0eea6c40],
.library-manifesto-text[data-v-0eea6c40] {
  margin: 14px 0 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 19px;
  line-height: 1.7;
}
.library-hero-side[data-v-0eea6c40] {
  padding: 22px;
  border: 1px dashed rgba(255, 240, 0, 0.28);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.04);
  transform: rotate(1.4deg);
}
.library-side-title[data-v-0eea6c40] {
  margin: 0;
  color: #fff;
  font-size: 28px;
}
.library-broadcast[data-v-0eea6c40] {
  margin-top: 18px;
}
.library-broadcast-inner[data-v-0eea6c40] {
  padding: 24px 28px;
  transform: rotate(0.5deg);
}
.library-grid[data-v-0eea6c40] {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-top: 18px;
}
.library-card[data-v-0eea6c40] {
  --card-tilt: 0deg;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 100%;
  transform: rotate(var(--card-tilt));
}
.library-card[data-v-0eea6c40]:nth-child(1) {
  --card-tilt: -1deg;
}
.library-card[data-v-0eea6c40]:nth-child(2) {
  --card-tilt: 0.7deg;
}
.library-card[data-v-0eea6c40]:nth-child(3) {
  --card-tilt: -0.5deg;
}
.library-card-title[data-v-0eea6c40],
.library-manifesto-title[data-v-0eea6c40] {
  margin: 0;
  color: #fff;
  font-size: clamp(28px, 4vw, 44px);
  line-height: 1.05;
}
.library-card-link[data-v-0eea6c40] {
  width: fit-content;
  margin-top: auto;
  padding: 12px 18px;
  border-radius: 999px;
  border: 2px solid rgba(255, 240, 0, 0.34);
  color: #fff000;
  background: rgba(255, 240, 0, 0.08);
  font-size: 15px;
  font-weight: 700;
  transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;
}
.library-card-link[data-v-0eea6c40]:hover {
  transform: translateY(-2px);
  color: #171203;
  background: #fff000;
}
.library-manifesto[data-v-0eea6c40] {
  margin-top: 18px;
  padding: 28px;
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.85fr);
  gap: 18px;
}
.library-code[data-v-0eea6c40] {
  margin: 0;
  padding: 20px;
  border-radius: 24px;
  overflow-x: auto;
  background: rgba(0, 0, 0, 0.44);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #fff790;
  font-size: 15px;
  line-height: 1.7;
}
.library-code code[data-v-0eea6c40] {
  font-family: "Comic Sans", "Smiley Sans", Arial, sans-serif;
}
@media (max-width: 980px) {
.library-hero[data-v-0eea6c40],
  .library-manifesto[data-v-0eea6c40] {
    grid-template-columns: 1fr;
}
.library-grid[data-v-0eea6c40] {
    grid-template-columns: 1fr;
}
}
@media (max-width: 720px) {
.library-page[data-v-0eea6c40] {
    width: min(calc(100vw - 18px), 1280px);
    padding-top: 20px;
}
.library-hero[data-v-0eea6c40],
  .library-broadcast-inner[data-v-0eea6c40],
  .library-card[data-v-0eea6c40],
  .library-manifesto[data-v-0eea6c40] {
    padding: 20px 18px;
    border-radius: 24px;
}
.library-lead[data-v-0eea6c40],
  .library-side-copy[data-v-0eea6c40],
  .library-broadcast-copy[data-v-0eea6c40],
  .library-card-copy[data-v-0eea6c40],
  .library-manifesto-text[data-v-0eea6c40] {
    font-size: 17px;
}
.library-side-title[data-v-0eea6c40] {
    font-size: 24px;
}
}
`, "",{"version":3,"sources":["webpack://./src/views/LibraryView.vue"],"names":[],"mappings":";AA2DA;EACE,sCAAsC;EACtC,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;AAEA;;;;EAIE,2CAA2C;EAC3C,mBAAmB;EACnB;;2EAEyE;EACzE;;2CAEyC;AAC3C;AAEA;EACE,aAAa;EACb,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,0BAA0B;AAC5B;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;AAEA;EACE,SAAS;EACT,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB;;iCAE+B;AACjC;AAEA;;;;;EAKE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;AAC3B;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mCAAmC;AACrC;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,oBAAoB;AACtB;AAEA;;EAEE,SAAS;EACT,WAAW;EACX,iCAAiC;EACjC,iBAAiB;AACnB;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;EACzC,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sEAAsE;AACxE;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;AACrB;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,8DAA8D;EAC9D,SAAS;AACX;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,2DAA2D;AAC7D;AAEA;AACE;;IAEE,0BAA0B;AAC5B;AAEA;IACE,0BAA0B;AAC5B;AACF;AAEA;AACE;IACE,sCAAsC;IACtC,iBAAiB;AACnB;AAEA;;;;IAIE,kBAAkB;IAClB,mBAAmB;AACrB;AAEA;;;;;IAKE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AACF","sourcesContent":["<template>\n  <section class=\"library-page\">\n    <section class=\"library-hero\">\n      <div class=\"library-hero-main\">\n        <p class=\"library-kicker\">BV627 MEDIA ASSET STORAGE TERMINAL</p>\n        <h1 class=\"library-title\">资源库</h1>\n        <p class=\"library-lead\">\n          这里不是普通下载页，这里是 BV627 媒体资产暂时决定离开服务器、前往你设备里的中转大厅。\n          每一份素材都很安静地躺着，但姿态上仍然保持一种夸张到略带庄严的抽象感。\n        </p>\n      </div>\n\n      <div class=\"library-hero-side\">\n        <p class=\"library-side-title\">下载须知</p>\n        <p class=\"library-side-copy\">\n          点击下载，不代表你只是拿走了一个文件。\n          更准确地说，你是把一小块 BV627 的视觉噪声、品牌空气和气氛材料打包带走了。\n        </p>\n      </div>\n    </section>\n\n    <section class=\"library-broadcast\">\n      <div class=\"library-broadcast-inner\">\n        <p class=\"library-broadcast-kicker\">特别播报</p>\n        <p class=\"library-broadcast-copy\">\n          本资源库采用数组召唤制，不靠后台，不靠搜索，也不靠任何看起来很高级其实未必有用的东西。\n          只需要标题、介绍、下载链接，素材就会自己排队出现。\n        </p>\n      </div>\n    </section>\n\n    <section class=\"library-grid\">\n      <article\n        v-for=\"(asset, index) in assetLibraryItems\"\n        :key=\"asset.title\"\n        class=\"library-card\"\n      >\n        <p class=\"library-card-index\">ASSET {{ String(index + 1).padStart(2, \"0\") }}</p>\n        <h2 class=\"library-card-title\">{{ asset.title }}</h2>\n        <p class=\"library-card-copy\">{{ asset.description }}</p>\n        <a\n          class=\"library-card-link\"\n          :href=\"asset.downloadUrl\"\n          target=\"_blank\"\n          rel=\"noreferrer\"\n          :download=\"asset.title\"\n        >\n          立即接走这个素材\n        </a>\n      </article>\n    </section>\n  </section>\n</template>\n\n<script setup>\nimport { assetLibraryItems } from \"@/data/assetLibrary\";\n</script>\n\n<style scoped>\n.library-page {\n  width: min(1280px, calc(100vw - 28px));\n  margin: 0 auto;\n  padding: 28px 0 56px;\n  color: #f7f1e8;\n}\n\n.library-hero,\n.library-broadcast-inner,\n.library-card,\n.library-manifesto {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 32px;\n  background:\n    radial-gradient(circle at top left, rgba(255, 240, 0, 0.14), transparent 24%),\n    linear-gradient(150deg, rgba(24, 18, 10, 0.96), rgba(10, 11, 16, 0.96));\n  box-shadow:\n    0 24px 60px rgba(0, 0, 0, 0.36),\n    inset 0 1px 0 rgba(255, 255, 255, 0.06);\n}\n\n.library-hero {\n  padding: 30px;\n  display: grid;\n  grid-template-columns: minmax(0, 1.7fr) minmax(280px, 0.9fr);\n  gap: 18px;\n  transform: rotate(-0.6deg);\n}\n\n.library-kicker,\n.library-broadcast-kicker,\n.library-card-index {\n  margin: 0 0 10px;\n  color: #fff000;\n  font-size: 12px;\n  letter-spacing: 4px;\n  text-transform: uppercase;\n}\n\n.library-title {\n  margin: 0;\n  color: #fffdf7;\n  font-size: clamp(56px, 11vw, 110px);\n  line-height: 0.88;\n  text-shadow:\n    0 0 18px rgba(255, 240, 0, 0.18),\n    4px 4px 0 rgba(0, 0, 0, 0.32);\n}\n\n.library-lead,\n.library-side-copy,\n.library-broadcast-copy,\n.library-card-copy,\n.library-manifesto-text {\n  margin: 14px 0 0;\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 19px;\n  line-height: 1.7;\n}\n\n.library-hero-side {\n  padding: 22px;\n  border: 1px dashed rgba(255, 240, 0, 0.28);\n  border-radius: 28px;\n  background: rgba(255, 255, 255, 0.04);\n  transform: rotate(1.4deg);\n}\n\n.library-side-title {\n  margin: 0;\n  color: #fff;\n  font-size: 28px;\n}\n\n.library-broadcast {\n  margin-top: 18px;\n}\n\n.library-broadcast-inner {\n  padding: 24px 28px;\n  transform: rotate(0.5deg);\n}\n\n.library-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 18px;\n  margin-top: 18px;\n}\n\n.library-card {\n  --card-tilt: 0deg;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 100%;\n  transform: rotate(var(--card-tilt));\n}\n\n.library-card:nth-child(1) {\n  --card-tilt: -1deg;\n}\n\n.library-card:nth-child(2) {\n  --card-tilt: 0.7deg;\n}\n\n.library-card:nth-child(3) {\n  --card-tilt: -0.5deg;\n}\n\n.library-card-title,\n.library-manifesto-title {\n  margin: 0;\n  color: #fff;\n  font-size: clamp(28px, 4vw, 44px);\n  line-height: 1.05;\n}\n\n.library-card-link {\n  width: fit-content;\n  margin-top: auto;\n  padding: 12px 18px;\n  border-radius: 999px;\n  border: 2px solid rgba(255, 240, 0, 0.34);\n  color: #fff000;\n  background: rgba(255, 240, 0, 0.08);\n  font-size: 15px;\n  font-weight: 700;\n  transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;\n}\n\n.library-card-link:hover {\n  transform: translateY(-2px);\n  color: #171203;\n  background: #fff000;\n}\n\n.library-manifesto {\n  margin-top: 18px;\n  padding: 28px;\n  display: grid;\n  grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.85fr);\n  gap: 18px;\n}\n\n.library-code {\n  margin: 0;\n  padding: 20px;\n  border-radius: 24px;\n  overflow-x: auto;\n  background: rgba(0, 0, 0, 0.44);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  color: #fff790;\n  font-size: 15px;\n  line-height: 1.7;\n}\n\n.library-code code {\n  font-family: \"Comic Sans\", \"Smiley Sans\", Arial, sans-serif;\n}\n\n@media (max-width: 980px) {\n  .library-hero,\n  .library-manifesto {\n    grid-template-columns: 1fr;\n  }\n\n  .library-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 720px) {\n  .library-page {\n    width: min(calc(100vw - 18px), 1280px);\n    padding-top: 20px;\n  }\n\n  .library-hero,\n  .library-broadcast-inner,\n  .library-card,\n  .library-manifesto {\n    padding: 20px 18px;\n    border-radius: 24px;\n  }\n\n  .library-lead,\n  .library-side-copy,\n  .library-broadcast-copy,\n  .library-card-copy,\n  .library-manifesto-text {\n    font-size: 17px;\n  }\n\n  .library-side-title {\n    font-size: 24px;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
